export default class NacionalidadeService {
    constructor(resource) {
        this._resource = resource('corpore/nacionalidade{/id}');
    }

    get(id) {
        return this._resource
            .get({id})
            .then(res => res.json(), err => {
                console.log(err);
                throw new Error('Não foi possível obter as nacionalidades');
            })
    }

    getNacionalidades() {
        return this._resource
            .get()
            .then(res => res.json(), err => {
                console.log(err);
                throw new Error('Não foi possível obter a nacionalidade');
            })
    }
}


// WEBPACK FOOTER //
// ./src/domain/corpore/NacionalidadeService.js